"use client";
import './assets/Header.css';const _ = "_header_psetr_1", e = "_wide_psetr_16", t = "__wide_psetr_21", o = "__center_psetr_32", s = "_logo_link_psetr_36", i = "_logo_image_psetr_41", n = "_small_psetr_48", r = "_logo_text_psetr_53", c = "_white_psetr_64", l = "_violet_psetr_69", a = "_orange_psetr_74", p = "_gray_psetr_79", d = "_red_psetr_84", g = "_notice_psetr_89", h = "_adaptive_psetr_95", k = "_hide_on_desktop_psetr_112", m = "_hide_on_mobile_psetr_120", v = "_hide_psetr_112", w = "_relink_psetr_132", x = "_relink_image_psetr_138", y = "_active_psetr_148", b = {
  header: _,
  wide: e,
  _wide: t,
  _center: o,
  logo_link: s,
  logo_image: i,
  small: n,
  logo_text: r,
  white: c,
  violet: l,
  orange: a,
  gray: p,
  red: d,
  notice: g,
  adaptive: h,
  hide_on_desktop: k,
  hide_on_mobile: m,
  hide: v,
  relink: w,
  relink_image: x,
  active: y
};
export {
  b as s
};
